/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TenantsResponseDto = {
  /**
   * Unique identifier of the tenant.
   */
  id: number;
  /**
   * Name of the tenant.
   */
  name: string;
  /**
   * Tenant registration number.
   */
  registrationNumber?: string;
  /**
   * Tenant contact email.
   */
  email?: string;
  /**
   * Date and time when the tenant was created.
   */
  createdAt: string;
  /**
   * Date and time when the tenant was last activated.
   */
  lastActivatedAt: string;
  /**
   * Date and time when the tenant was last suspended.
   */
  lastSuspendedAt?: string;
  /**
   * Date and time when the tenant was last deactivated.
   */
  lastDeactivatedAt?: string;
  /**
   * Current status of the tenant.
   */
  status: TenantsResponseDto.status;
  /**
   * Default locale for the tenant users.
   */
  userLocale: TenantsResponseDto.userLocale;
  /**
   * Default locale for the tenant clients.
   */
  clientLocale: TenantsResponseDto.clientLocale;
};
export namespace TenantsResponseDto {
  /**
   * Current status of the tenant.
   */
  export enum status {
    ACTIVE = 'ACTIVE',
    ACTIVATION_IN_PROGRESS = 'ACTIVATION_IN_PROGRESS',
    SUSPENDED = 'SUSPENDED',
    SUSPEND_IN_PROGRESS = 'SUSPEND_IN_PROGRESS',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATE_IN_PROGRESS = 'DEACTIVATE_IN_PROGRESS',
  }
  /**
   * Default locale for the tenant users.
   */
  export enum userLocale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
  /**
   * Default locale for the tenant clients.
   */
  export enum clientLocale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
}

